import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import ProviderLayout from '../../components/ProviderLayout';
import { apiFetch } from '../../api';

const PRIMARY = '#4F46E5';

function money(v) {
  const n = Number(v);
  if (!v || Number.isNaN(n)) return "0 so'm";
  return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + " so'm";
}

export default function ProviderEarningsPage() {
  const { auth } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await apiFetch('/api/provider/stats', auth.token);
      if (!res.ok) throw new Error();
      setStats(await res.json());
    } catch {
      setStats(null);
      setError('Daromad ma\'lumotini yuklashda xatolik yuz berdi.');
    } finally {
      setLoading(false);
    }
  }, [auth.token]);

  useEffect(() => { load(); }, [load]);

  return (
    <ProviderLayout title="Daromad">
      {loading ? (
        <div style={s.center}>Yuklanmoqda...</div>
      ) : error ? (
        <div style={s.error}>{error}</div>
      ) : (
        <>
          <div style={s.cardsRow}>
            <Card label="Shu hafta" value={money(stats?.weekEarnings)} />
            <Card label="Shu oy" value={money(stats?.monthEarnings)} />
          </div>

          <div style={s.block}>
            <div style={s.blockTitle}>Bajarilgan buyurtmalar</div>
            <Row label="Jami" value={stats?.completedTotal ?? 0} />
            <Row label="Shu hafta" value={stats?.completedWeek ?? 0} />
            <Row label="Shu oy" value={stats?.completedMonth ?? 0} />
            <Row label="O'rtacha reyting" value={Number(stats?.avgRating ?? 0).toFixed(1)} />
          </div>

          {Array.isArray(stats?.topServices) && stats.topServices.length > 0 && (
            <div style={s.block}>
              <div style={s.blockTitle}>Ommabop xizmatlar</div>
              {stats.topServices.map((t, i) => (
                <Row key={i} label={t.name || t.categoryName || `#${i + 1}`} value={t.count ?? t.ordersCount ?? ''} />
              ))}
            </div>
          )}
        </>
      )}
    </ProviderLayout>
  );
}

function Card({ label, value }) {
  return (
    <div style={s.card}>
      <div style={s.cardValue}>{value}</div>
      <div style={s.cardLabel}>{label}</div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div style={s.row}>
      <span style={s.rowLabel}>{label}</span>
      <span style={s.rowValue}>{value}</span>
    </div>
  );
}

const s = {
  center: { textAlign: 'center', padding: '48px', color: 'var(--slate-400)' },
  error: {
    background: 'var(--danger-tint)',
    border: '1px solid #FCA5A5',
    borderRadius: '10px',
    padding: '12px 14px',
    color: 'var(--danger)',
    fontSize: '14px',
  },
  cardsRow: { display: 'flex', gap: '12px', marginBottom: '16px' },
  card: {
    flex: 1,
    background: PRIMARY,
    borderRadius: '16px',
    padding: '18px 16px',
    color: 'var(--on-accent)',
  },
  cardValue: { fontSize: '20px', fontWeight: '800', lineHeight: 1.2 },
  cardLabel: { fontSize: '13px', opacity: 0.85, marginTop: '6px' },
  block: {
    background: 'var(--surface)',
    borderRadius: '16px',
    border: '1px solid #E2E8F0',
    padding: '16px',
    marginBottom: '12px',
  },
  blockTitle: { fontSize: '15px', fontWeight: '700', color: 'var(--slate-900)', marginBottom: '10px' },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '9px 0',
    borderBottom: '1px solid #F1F5F9',
    fontSize: '14px',
  },
  rowLabel: { color: '#64748B' },
  rowValue: { color: 'var(--slate-900)', fontWeight: '600' },
};
